import Vue from 'vue'
import Vuex from 'vuex'
import usuario from './modules/usuario/usuario'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    login: false
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    usuario
  }
})
